import { getPartnerConfigBySlug } from "@/lib/partners/registry"
import { getPartnerSlugFromPathname } from "@/lib/partners/partner-path"
import { normalizeSellerReferralCode } from "@/lib/seller-referral/seller-code-cookie"

export function getForcedSellerReferralCodeForSlug(
  slug: string | null | undefined,
): string | null {
  const config = getPartnerConfigBySlug(slug)
  return normalizeSellerReferralCode(config?.forcedSellerReferralCode ?? null)
}

export function getForcedSellerReferralCodeFromPathname(
  pathname: string | null | undefined,
): string | null {
  return getForcedSellerReferralCodeForSlug(getPartnerSlugFromPathname(pathname))
}
